export enum EStaticMapTypes {
  satellite = 'sat',
  map = 'map',
}

export enum EMapTypes {
  satellite = 'yandex#hybrid',
  map = 'yandex#map',
}
